export default __webpack_public_path__ + "static/wood-style-3-d7a2002c7daa8f8e59f024948e7bec25.png";